import axios from 'axios';
import { cWarn } from '../components/igtm/CustomLogger';

export const getTextContent = (context) => {
    const apiPath = `${process.env.REACT_APP_API_URL}/textdata`;
    axios.get(apiPath,{
        timeout: 30000,
        withCredentials:true
    }).then(res => {
        context.setState({textContent:res.data});
    }).catch(err => {
       // console.log('caught the error');
       cWarn(err);
    });

};